import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "./BasicBitmapCountUp";
import {KMDGameAssets} from "../KMDGameAssets";

export class KMDToggle extends PIXI.Container implements StageLayer {

    private _winAmount: BasicBitmapCountUp;

    constructor() {
        super();
        this.name = "KMDToggle";

        this.init();
    }

    private init(): void {
        this._winAmount = new BasicBitmapCountUp({
            fontName: KMDGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 16,
            tint: 0xffffff
        }, 288);
        this._winAmount.visible = false;
        this._winAmount.position.set(360, 316);
        this._winAmount.stopAt(-1);

        this.addChild(this._winAmount);
    }

    public showToggleAmount(amount: number): void {
        if (this._winAmount.currentCountValue === amount) {
            return;
        }

        this._winAmount.stopAt(amount);
        this._winAmount.visible = true;
    }

    public hideToggleAmount(): void {
        this._winAmount.visible = false;
        this._winAmount.stopAt(-1);
    }
}